// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.js";
import "./index.css";

// ✅ Correct import name (matches firebase.js)
import { messagingPromiseInstance } from "./firebase.js";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      // ✅ Register your service worker for FCM
      const registration = await navigator.serviceWorker.register(
        "/firebase-messaging-sw.js"
      );

      console.log("✅ Service Worker registered:", registration);

      // ✅ Get messaging instance from firebase.js
      const messaging = await messagingPromiseInstance;

      if (!messaging) {
        console.warn("⚠️ Messaging not supported in this environment.");
        return;
      }

      // ✅ Attach the service worker to messaging
      messaging.serviceWorkerRegistration = registration;

      console.log("✅ Service Worker linked for FCM token requests");
    } catch (err) {
      console.error("❌ Service Worker registration failed:", err);
    }
  });
}
